const onboardStateFilters = (state = {}, action) => {
  switch (action.type) {
  case 'SET_FILTER_STATE_ONBOARD_DATA':
    return action.payload;
  case 'ADD_FILTER_STATE_ONBOARD_DATA':
    return { ...state, [action.payload.type]: action.payload.data };
  default:
    return state;
  }
};

export default onboardStateFilters;
